module.exports = __webpack_public_path__ + "img/DEU.5feaece4.svg";